/**
 * URL slugs for day-view variants of `/spotprisen`. "i-dag" is implicit
 * (no segment in URL) and represented as `null` in {@link DayView}.
 *
 * Lives in `#lib/` rather than the route's `_meta.ts` so the param
 * matcher at `src/params.ts` doesn't have to import
 * across the rest-param folder name.
 */
export const DAY_VIEWS = ["i-gar", "i-morgen"] as const;

export type DayViewSlug = (typeof DAY_VIEWS)[number];
export type DayView = DayViewSlug | null;

export const isDayViewSlug = (s: string): s is DayViewSlug =>
	(DAY_VIEWS as readonly string[]).includes(s);
